import * as React from "react";
import Svg, { Path, G, Defs, LinearGradient, Stop } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={112}
      height={112}
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M56 0C25.074 0 0 25.071 0 56c0 30.927 25.073 56 56 56 30.928 0 56.001-25.073 56.001-56 0-30.928-25.072-56-56-56zm0 98.45c-23.444 0-42.45-19.005-42.45-42.45 0-23.444 19.006-42.45 42.45-42.45 23.445 0 42.45 19.005 42.45 42.45 0 23.444-19.005 42.45-42.45 42.45z"
        fill="#B7B7B7"
      />
      <Path
        d="M46.36 43.986l18.104 4.556a2.798 2.798 0 012.094 3.053l-2.471 18.292h-3.61l1.237-16.53-21.531-.771 6.178-8.601z"
        fill="#002F4A"
      />
      <Path
        d="M64.087 69.888l5.318 3.485h-9.081l.153-3.485h3.61z"
        fill="#000"
      />
      <Path
        d="M68.002 34.32l2.665.512 1.676 1.163.45.71a.205.205 0 01-.34.23L72 36.302l-1.504-.694-.891-.126.47.867.45.235a.213.213 0 01-.168.39l-.57-.192-1.307-1.03h-.48v-1.434.001z"
        fill="url(#paint0_linear_1901_1047)"
      />
      <Path
        d="M50.84 20.949l.354 2.362a15.843 15.843 0 002.638 5.29l.102.134a15.799 15.799 0 001.805 1.996l1.482 1.383 10.988 2.028v1.714l-13.197-.737a2.507 2.507 0 01-1.306-.613L52.26 33.21a8.427 8.427 0 01-2.091-2.883l-.879-1.995-1.415-6.707 2.966-.676-.001-.001z"
        fill="#FFB22F"
      />
      <Path
        d="M69.25 37.036a.31.31 0 01-.374-.345l1.063-7.627c.047-.331-.06-.616-.292-.78l-1.536-1.082a.31.31 0 01-.05-.463l.075-.082a.31.31 0 01.407-.044l1.6 1.128c.35.247.512.677.442 1.177l-1.096 7.858a.31.31 0 01-.238.26h-.001z"
        fill="#D9D9D9"
      />
      <Path
        d="M68.972 27.423c-.71 1.882-1.91 3.408-2.683 3.408-.773 0-.825-1.526-.116-3.408s1.91-3.408 2.683-3.408c.773 0 .825 1.526.116 3.408z"
        fill="#1D1D1B"
      />
      <Path
        d="M97.887 67.958l-.984-2.013a5.719 5.719 0 00-5.71-3.183c-2.348.237-5.274.77-7.54 1.951l14.234 3.244v.001zM49.043 66.634l2.866 2.64a7.992 7.992 0 005.414 2.113h11.21c2.179 0 4.264-.89 5.771-2.464l1.977-2.064-4.337 6.843-12.77 2.11-5.869-2.492-3.313-2.489-.95-4.197h.001z"
        fill="#0080E9"
      />
      <Path
        d="M63.597 30.892c.773 0 1.4-1.498 1.4-3.347s-.627-3.348-1.4-3.348c-.773 0-1.4 1.499-1.4 3.348 0 1.849.627 3.347 1.4 3.347zM16.734 70.93l-1.07 5.793c-.183.988 1.006 1.632 1.734.939l5.029-4.79-5.692-1.942h-.001zM66.784 76.7l-.675 1.038a9.947 9.947 0 01-8.681 4.528l-10.84-.286a6.933 6.933 0 01-5.918-3.736l-2.275-4.388-4.743-7.562 12.4-1.162 5.38 10.288 15.35 1.28h.002z"
        fill="#1D1D1B"
      />
      <Path
        d="M95.708 84.861c4.118-4.118 4.118-10.795 0-14.913s-10.795-4.118-14.913 0-4.118 10.795 0 14.913 10.795 4.118 14.913 0z"
        fill="#3C3C3B"
      />
      <Path
        d="M88.25 84.69c-4.017 0-7.285-3.268-7.285-7.286 0-4.017 3.268-7.286 7.286-7.286 4.017 0 7.286 3.269 7.286 7.286 0 4.018-3.269 7.287-7.286 7.287z"
        fill="#B1B1B1"
      />
      <Path
        d="M88.25 84.056a6.66 6.66 0 01-6.652-6.653 6.66 6.66 0 016.653-6.652 6.66 6.66 0 016.653 6.652 6.66 6.66 0 01-6.653 6.653z"
        fill="#fff"
      />
      <Path
        d="M89.609 80.682a3.548 3.548 0 10-2.716-6.556 3.548 3.548 0 002.716 6.556z"
        fill="#3C3C3B"
      />
      <Path
        d="M90.33 72.446c1.858.537 3.294 2.322 3.517 4.25.34 2.371-1.066 4.829-3.346 5.59a5.98 5.98 0 002.12-2.138c1.59-2.735.482-6.223-2.291-7.702zM86.418 82.458c-3.58-.958-4.946-5.309-2.757-8.24a5.125 5.125 0 011.945-1.58l.385-.157c.133-.04.264-.082.395-.12-4.32 2.121-4.302 8.005.032 10.096v.001z"
        fill="#ECECEC"
      />
      <Path
        d="M87.499 76.162l-2.97 1.591.573 1.072 2.97-1.591-.573-1.072z"
        fill="#1D1D1B"
      />
      <Path
        d="M85.197 79.52a.911.911 0 01-.827-.528L77.137 63.44a.911.911 0 111.653-.769l7.232 15.553a.911.911 0 01-.826 1.295z"
        fill="#B1B1B1"
      />
      <Path
        d="M88.252 78.316a.91.91 0 01-.762-.41L76.945 61.958a.911.911 0 011.52-1.005L89.01 76.9a.911.911 0 01-.76 1.415h.002z"
        fill="#B1B1B1"
      />
      <Path
        d="M74.769 77.122l.336-2.192a12.031 12.031 0 015.243-8.205l1.647-1.093a12.03 12.03 0 0117.237 4.316l.534.99a1.13 1.13 0 01-.923 1.663l-2.762.174a48.92 48.92 0 00-19.671 5.518 1.13 1.13 0 01-1.642-1.172v.001z"
        fill="#0196FF"
      />
      <Path
        d="M38.462 84.86c4.119-4.118 4.119-10.795 0-14.913-4.118-4.118-10.794-4.118-14.913 0-4.118 4.118-4.118 10.795 0 14.913 4.119 4.118 10.795 4.118 14.913 0z"
        fill="#3C3C3B"
      />
      <Path
        d="M31.006 84.69c-4.018 0-7.287-3.268-7.287-7.286 0-4.017 3.269-7.286 7.287-7.286 4.017 0 7.286 3.269 7.286 7.286 0 4.018-3.269 7.287-7.287 7.287z"
        fill="#B1B1B1"
      />
      <Path
        d="M31.006 84.056a6.66 6.66 0 01-6.653-6.653 6.66 6.66 0 016.653-6.652 6.66 6.66 0 016.652 6.652 6.66 6.66 0 01-6.652 6.653z"
        fill="#fff"
      />
      <Path
        d="M34.299 78.721a3.548 3.548 0 10-6.586-2.644A3.548 3.548 0 0034.3 78.72z"
        fill="#3C3C3B"
      />
      <Path
        d="M33.083 72.446c1.859.537 3.295 2.322 3.518 4.25.34 2.371-1.066 4.829-3.346 5.59a5.98 5.98 0 002.12-2.138c1.59-2.735.482-6.223-2.292-7.702zM29.172 82.458c-3.58-.958-4.946-5.309-2.757-8.24a5.125 5.125 0 011.945-1.58l.384-.157c.133-.04.265-.082.396-.12-4.32 2.121-4.302 8.005.032 10.096v.001z"
        fill="#ECECEC"
      />
      <Path
        d="M41.638 80.334a.912.912 0 010-1.823 4.946 4.946 0 004.737-3.572l.703-2.46-3.388-2.406a.911.911 0 111.056-1.486l3.914 2.779a.911.911 0 01.35.994l-.881 3.08a6.695 6.695 0 01-2.425 3.533 6.698 6.698 0 01-4.064 1.36h-.002z"
        fill="#1D1D1B"
      />
      <Path
        d="M41.452 76.419H24.44a1.75 1.75 0 00-1.75 1.75v2.507c0 .095.008.188.021.279l-.715.506.705.998.619-.438c.303.253.693.405 1.12.405h17.013a1.75 1.75 0 001.75-1.75V78.17a1.75 1.75 0 00-1.75-1.75z"
        fill="#1D1D1B"
      />
      <Path
        d="M26.152 77.796h13.585c.33 0 .598.268.598.598v2.057c0 .33-.267.598-.598.598H26.152a.597.597 0 01-.597-.598v-2.057c0-.33.267-.598.597-.598z"
        fill="#D9D9D9"
      />
      <G fill="#1D1D1B">
        <Path d="M29.387 80.337h-1.041a.395.395 0 01-.329-.613l.69-1.04a.395.395 0 01.33-.175h1.04c.316 0 .504.35.33.613l-.691 1.039a.395.395 0 01-.329.176zM33.12 80.337h-1.04a.395.395 0 01-.33-.613l.691-1.04a.395.395 0 01.329-.175h1.041c.315 0 .503.35.329.613l-.69 1.039a.395.395 0 01-.33.176zM36.855 80.337h-1.042a.395.395 0 01-.329-.613l.69-1.04a.395.395 0 01.33-.175h1.041c.315 0 .503.35.328.613l-.69 1.039a.395.395 0 01-.328.176z" />
      </G>
      <Path
        d="M69.776 43.069s4.702 2.658 8.646 8.213c1.022 1.44 1.829 3.018 2.446 4.671.396 1.058 1.018 2.302 1.757 2.302l.597 4.636-2.96 1.45-10.486-21.273z"
        fill="#0080E9"
      />
      <Path
        d="M47.456 75.812H19.375a3.045 3.045 0 01-3.004-3.547l.693-7.027c.116-1.107.383-2.195.822-3.218 1.736-4.056 5.82-6.962 10.4-6.962h17.523a4.318 4.318 0 014.318 4.319l.41 13.354a3.08 3.08 0 01-3.08 3.08z"
        fill="#0196FF"
      />
      <Path d="M56.409 69.888l4.71 3.485h-8.475l.154-3.485h3.61z" fill="#000" />
      <Path
        d="M50.127 64.975s-.527 8.172 7.154 8.172c7.68 0 16.81 1.472 16.81-8.887 0-5.44-4.407-15.795-9.449-22.935h3.852s10.74 6.912 12.373 18.138a9.376 9.376 0 01-2.655 7.977c-2.653 2.654-3.01 4.452-3.65 6.176a6.67 6.67 0 01-6.252 4.347H53.543c-5.003 0-9.205-3.535-9.63-8.52-.047-.557-.073-3.6-.073-4.225l6.287-.243z"
        fill="#0196FF"
      />
      <Path
        d="M82.625 58.256l.597 4.635.445-.223a.279.279 0 00.15-.297l-.659-3.821a.28.28 0 00-.216-.226l-.317-.068z"
        fill="#D9D9D9"
      />
      <Path
        d="M76.281 39.635c.591 0 1.071-1.695 1.071-3.786 0-2.09-.48-3.785-1.071-3.785-.592 0-1.071 1.695-1.071 3.785s.48 3.786 1.071 3.786z"
        fill="#FFC200"
      />
      <Path
        d="M75.077 31.659h.942c.175 0 .317.142.317.316v7.748a.317.317 0 01-.317.317h-.942a.317.317 0 01-.316-.317v-7.748c0-.174.142-.316.316-.316z"
        fill="#D9D9D9"
      />
      <Path
        d="M74.761 31.975l-3.549 1.254c-.473.125-.95.232-1.43.32l-2.227.412a3.147 3.147 0 00-2.566 2.852l-.347 4.513h3.852l.415-.591a3.842 3.842 0 013.798-1.576l2.054.564v-7.748z"
        fill="#0196FF"
      />
      <Path
        d="M68.793 37.622a.305.305 0 01-.367-.224l-1.843-7.633a1.197 1.197 0 00-.587-.766l-2.04-1.117a.303.303 0 11.291-.533l2.04 1.117a1.8 1.8 0 01.886 1.157l1.844 7.632a.305.305 0 01-.224.367z"
        fill="#D9D9D9"
      />
      <Path d="M70.7 38.275l-1.846.303v-1.26l1.845.304v.653z" fill="#1D1D1B" />
      <Path
        d="M70.807 37.486h-.318a.303.303 0 00-.303.303v.318c0 .168.135.303.303.303h.318a.303.303 0 00.303-.303v-.318a.303.303 0 00-.303-.303z"
        fill="#B1B1B1"
      />
      <Path
        d="M66.783 34.105v-.098c0-.04.028-.073.067-.081l3.873-.792c.051-.01.1.029.1.082v.044c0 .04-.027.074-.065.082l-3.873.845a.083.083 0 01-.1-.081l-.002-.001z"
        fill="#D9D9D9"
      />
      <Path
        d="M48.834 56.295l-1.632-4.4a2.616 2.616 0 00-2.489-1.706l-14.757.204a2.616 2.616 0 00-2.352 1.549l-.692 1.546c-.33.738.21 1.57 1.018 1.57h.355c-2.565 0 18.458.003 20.548 1.237z"
        fill="#1D1D1B"
      />
      <Path
        d="M17.178 64.425l-3.762 2.048a1.36 1.36 0 00-.709 1.194v1.13c0 .72.56 1.314 1.278 1.357l2.58.155.613-5.885v.001z"
        fill="#F01614"
      />
      <Path
        d="M12.707 68.472v.326c0 .718.56 1.313 1.278 1.356l2.58.155.191-1.837h-4.05.001z"
        fill="#F29100"
      />
      <Path
        d="M16.532 70.643l-.868-.263.666-5.638.929-.73-.727 6.631z"
        fill="#D9D9D9"
      />
      <Path
        d="M45.025 68.944c.266-4.962-4.177-6.754-8.372-7.189-.289-.024-.74-.066-1.03-.092-.348-.016-.818-.042-1.166-.055-.159-.001-.614-.01-.78-.011-.5-.014-1.056.015-1.56.018-.32.019-.845.045-1.164.065-.291.03-.736.07-1.03.098-.439.061-.965.125-1.4.21-3.366.587-6.71 2.115-8.296 5.304-.31.625-.555 1.289-.665 1.983-.025-1.171.343-2.334.901-3.358 1.341-2.452 3.888-3.97 6.511-4.73.162-.043.624-.17.793-.214.313-.064.758-.172 1.067-.223.253-.04.693-.112.941-.15.308-.033.773-.089 1.08-.119.533-.035 1.219-.086 1.755-.089a29.869 29.869 0 012.16.03c.164.013.648.044.81.056.308.02.773.083 1.08.115.204.02.604.096.806.127.894.147 1.794.379 2.649.687.176.056.348.131.513.201.107.05.393.16.506.223l.495.252.061.032c.152.09.277.167.418.252 2.283 1.381 3.617 3.963 2.915 6.576h.002z"
        fill="#0080E9"
      />
      <Path
        d="M96.493 70.857c-.83-3.954-4.456-4.508-7.62-4.043-.216.038-.555.09-.773.127-.258.054-.607.124-.866.181-.116.03-.451.111-.573.141-.37.085-.772.216-1.14.315-.23.077-.609.198-.839.276-.207.079-.525.197-.734.274-.31.132-.682.285-.983.436-2.344 1.109-4.48 2.955-4.982 5.768a5.965 5.965 0 00-.077 1.688c-.26-.916-.231-1.902-.034-2.814.476-2.187 2.029-3.872 3.793-4.975.11-.064.423-.253.537-.32.216-.111.52-.282.736-.382.177-.08.484-.22.659-.298.218-.086.547-.22.766-.302.384-.13.876-.302 1.268-.408a21.193 21.193 0 011.589-.392c.123-.021.483-.091.604-.113.23-.043.584-.083.815-.117.154-.024.463-.04.617-.055a10.847 10.847 0 012.082.03c.141.011.282.036.419.06.088.019.32.05.417.078l.414.102.051.013c.13.042.237.08.358.119 1.958.647 3.47 2.42 3.495 4.61l.001.001z"
        fill="#0196FF"
      />
      <G fill="#0080E9">
        <Path d="M39.47 68.722H25.306v.555H39.47v-.555zM38.544 67.4H26.232v.555h12.312V67.4zM37.58 66.08H27.196v.554H37.58v-.555z" />
      </G>
      <Path
        d="M47.97 19.063l.788-1.506 1.823.595c.715.233 1.478-.162 1.597-.827l.303-1.677.433-.132c.288-.087.45-.357.375-.626l-.428-1.542.295-1.578c.102-.544-.13-1.101-.608-1.462L51.21 9.297a3.771 3.771 0 00-3.759-.428l-.044.02c-.996.444-1.679 1.282-1.852 2.262l-.673 3.8.043 3.281 3.042.832.001-.001z"
        fill="url(#paint1_linear_1901_1047)"
      />
      <Path
        d="M49.193 18.282l-2.623-.661-3.04.33 1.609 2.008 2.772.912 1.282-1.324v-1.265z"
        fill="url(#paint2_linear_1901_1047)"
      />
      <Path
        d="M56.409 69.888l4.386-20.674a2.797 2.797 0 00-2.307-3.326l-12.126-1.902-10.902-.837c-1.807 6.077.487 9.135 2.605 9.319.044.004.088.006.133.009l16.086.906-1.486 16.506h3.61z"
        fill="#003F62"
      />
      <Path
        d="M49.71 18.228a.762.762 0 00-1.105.266c-.374.695-1.053 1.16-1.829 1.16-.902 0-1.673-.628-1.984-1.515a.766.766 0 00-.722-.518h-.008a3.39 3.39 0 00-2.082.705l-.026.02c-.15.115-.292.242-.426.378-5.207 5.09-6.067 24.424-6.067 24.424l10.901.838s2.832-7.1 4.725-23.206c.124-1.048-.566-1.98-1.375-2.552h-.001z"
        fill="#FFC32F"
      />
      <Path
        d="M44.884 14.949l.09-6.188 1.153.179-.225-1.171 1.13.464 1.157-1.322 2.493.873 3.157.223-.541.693.447.566-.505 2.034s-2.826-1.104-4.747 2.574c0 0-1.443-3.835-2.302.281l-1.307.794z"
        fill="#1A1A1A"
      />
      <Path
        d="M48.493 13.873l.265 3.684 2.987 1.139.573-1.104s-1.513-1.308.272-1.308l-.11-.638s-1.294-.154-1.662 1.291l-1.663.014-.662-3.079v.001z"
        fill="#1A1A1A"
      />
      <Path
        opacity={0.5}
        d="M36.122 43.198l10.239.788s2.71-6.798 4.601-22.175c-2.688 6.158-5.128 19.06-14.84 21.387z"
        fill="#FFB22F"
      />
      <G>
        <Path
          d="M64.371 35.759l2.666.512 1.675 1.164.45.71a.205.205 0 01-.34.23l-.452-.633-1.504-.695-.89-.126.469.867.45.235a.213.213 0 01-.167.391l-.57-.193-1.308-1.03h-.48v-1.433h.001z"
          fill="url(#paint3_linear_1901_1047)"
        />
        <Path
          d="M43.863 21.61l.13.865a15.844 15.844 0 002.637 5.29l.102.134a15.807 15.807 0 001.805 1.996l1.482 1.382 14.576 4.304v1.713l-14.874-2.34c-.823-.217-2.97-1.065-3.558-1.59l-.535-.48a16.393 16.393 0 01-5.264-9.698l-.158-1.018a1.85 1.85 0 113.657-.558z"
          fill="#FFCF3B"
        />
      </G>
      <Path
        d="M68.856 39.299a1.872 1.872 0 10-2.873-2.398 1.872 1.872 0 002.873 2.398z"
        fill="#1D1D1B"
      />
      <Path
        d="M67.42 39.536a1.433 1.433 0 10.001-2.866 1.433 1.433 0 000 2.866z"
        fill="#B1B1B1"
      />
      <G>
        <Path
          d="M49.138 17.583a.304.304 0 01-.298-.248l-.9-4.855a.304.304 0 11.598-.11l.899 4.855a.304.304 0 01-.298.358h-.001z"
          fill="#1D1D1B"
        />
        <Path
          d="M54.51 11.097s1.097-5.94-5.601-5.94c-6.699 0-5.016 9.233-5.016 9.233s5.016.063 5.016-2.136c0-2.198 5.6-1.157 5.6-1.157z"
          fill="#FFC32F"
        />
        <Path
          d="M50.49 10.953s2.818.079 5.141.635c.141.035.225-.151.107-.234l-1.16-.82-2.09-.13a3.195 3.195 0 00-1.998.55z"
          fill="#1A1A1A"
        />
        <Path
          d="M55.664 11.865a.46.46 0 01-.098-.011c-2.267-.544-5.056-.627-5.084-.628a.274.274 0 01-.147-.5 3.483 3.483 0 012.168-.595l2.09.13c.05.003.1.02.14.05l1.161.818a.4.4 0 01.136.498.4.4 0 01-.367.238h.001zm-4.012-1.122c.876.064 2.133.19 3.355.43l-.525-.37-2.012-.125a2.931 2.931 0 00-.818.065z"
          fill="#1D1D1B"
        />
        <Path
          d="M43.941 14.694h-.05a.304.304 0 01.006-.607c.009 0 .84.008 1.802-.128 1.233-.173 2.122-.498 2.569-.941.227-.224.337-.474.337-.763 0-.43.17-.787.502-1.064.587-.489 1.694-.7 3.289-.63 1.15.05 2.127.23 2.169.238a.304.304 0 01-.111.597c-1.056-.196-4.006-.53-4.96.262a.728.728 0 00-.281.597c0 .454-.175.856-.519 1.196-.55.543-1.533.918-2.92 1.112a14.02 14.02 0 01-1.833.132v-.001z"
          fill="#1D1D1B"
        />
        <Path
          d="M48.297 11.865a.422.422 0 11-.845 0 .422.422 0 01.845 0z"
          fill="#1A1A1A"
        />
      </G>
      <Path
        d="M94.936 26.645l-9.581-9.582-68.29 68.29 9.58 9.582 68.291-68.29z"
        fill="#B7B7B7"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_1901_1047"
          x1={72.8257}
          y1={35.6699}
          x2={68.0019}
          y2={35.6699}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFCDB1" />
          <Stop offset={0.2} stopColor="#FFBB93" />
          <Stop offset={1} stopColor="#FFA065" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_1901_1047"
          x1={49.6002}
          y1={8.47833}
          x2={48.6477}
          y2={20.9719}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFCDB1" />
          <Stop offset={0.2} stopColor="#FFBB93" />
          <Stop offset={1} stopColor="#FFA065" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_1901_1047"
          x1={46.3609}
          y1={8.59928}
          x2={46.3609}
          y2={20.0988}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFCDB1" />
          <Stop offset={0.2} stopColor="#FFBB93" />
          <Stop offset={1} stopColor="#FFA065" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_1901_1047"
          x1={69.1951}
          y1={37.1102}
          x2={64.3713}
          y2={37.1102}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFCDB1" />
          <Stop offset={0.2} stopColor="#FFBB93" />
          <Stop offset={1} stopColor="#FFA065" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
